import 'css-chunksrc/client/scenes/resourceEdition/assignCostProfileToResource/styles.scss';export default {
  "assignCostProfileToResource": "_assignCostProfileToResource_1ejfq_1",
  "list": "_list_1ejfq_10"
};